const ErrorPage = () => {
    return (
        <div>
            <h3 className="text-2xl">Oops!</h3>
            <i>Sorry, an unexpected error has occured.</i>
        </div>
    )
}

export default ErrorPage